import script from "./XCandles.vue?vue&type=script&lang=js"
export * from "./XCandles.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__